import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../components/Common/Index.style'
import { no162Style } from '../../../components/Article/No162.style'
import Page from '../../../components/Page/Page'
import PageHeader from '../../../components/PageHeader/PageHeader'
import Content from '../../../components/Content/Content'
import SectionTitle from '../../../components/SectioinTitle'
import BackBtn from '../../../components/Common/BackBtn'
import BreadCrumb from '../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '2023お出かけイベント情報 | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="にいがたイベントガイド" />
      <SectionTitle sectionTitle="2023お出かけイベント情報" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023春号 No.162 目次",
                path: "/no162"
              },
              {
                name: "イベントガイド"
              }
            ]}
          />
        <p>イベントなどは急きょ中止や変更となる場合があります。詳細は各施設にご確認ください。</p>
        
        <h3 css={style.subTitle01}>令和5年度&ensp;愛鳥週間用ポスター展</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>5/13（土）～7/9（日）</h4>
        <p>休館：月</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】愛鳥センター紫雲寺さえずりの里（新発田市）</span>&emsp;電話：<a href="tel:0254-41-4500">0254-41-4500</a><br />ホームページは<a href="https://www.pref.niigata.lg.jp/site/aicho/" target="_blank" rel="noreferrer">こちら</a></p>

        <hr />
        
        <h3 css={style.subTitle01}>夏井いつき句会ライブ</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/29（土・祝）13:30開場&ensp;14:00開演</h4>
        <p>料金：全席指定3,500円<br />未就学児童入場不可</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県民会館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-228-4481">025-228-4481</a><br />ホームページは<a href="https://www.niigata-kenminkaikan.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-14.png`}
          alt="夏井いつき"
          css={style.img(200, "15px 0 0 0")}
        />

        <hr />
        
        <h3 css={style.subTitle01}>原田治 展&emsp;「かわいい」の発見</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>5/7（日）まで</h4>
        <p>休館：月（5/1は開館）<br />料金：一般 1,200円&emsp;高校･大学生 900円<br />※障害者手帳をお持ちの方は無料</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立万代島美術館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-290-6655">025-290-6655</a><br />ホームページは<a href="https://banbi.pref.niigata.lg.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-15.png`}
          alt="原田治 展"
          css={style.img(500, "15px 0 0 0")}
        />
        
        <hr />
        
        <h3 css={style.subTitle01}>シャクナゲ・ツツジ展</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/11（火）～5/14（日）</h4>
        <p>休館：月（5/1は開館）<br />観賞温室入館料：一般600円、65歳以上500円、高校・大学生300円、小・中学生100円（土日祝日は小・中学生無料）</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立植物園（新潟市秋葉区）</span>&emsp;電話：<a href="tel:0250-24-6465">0250-24-6465</a><br />ホームページは<a href="https://botanical.greenery-niigata.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-16.png`}
          alt="シャクナゲ・ツツジ展"
          css={style.img(300, "15px 0 0 0")}
        />
        
        <hr />
        
        <h3 css={style.subTitle01}>ポケモン化石博物館</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>6/25（日）まで</h4>
        <p>休館：火、5/8<br />料金（入館料込み）：一般1,380円、小・中学生600円</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立自然科学館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-283-3331">025-283-3331</a><br />ホームページは<a href="https://www.sciencemuseum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-17.png`}
          alt="ポケモン化石博物館"
          css={style.img(300, "15px 0 0 0")}
        />
        <p css={style.imgCap}>©2023 Pokémon. ©1995-2023 Nintendo/Creatures Inc./GAME FREAK inc.ポケットモンスター・ポケモン・Pokémonは 任天堂・クリーチャーズ・ゲームフリークの登録商標です。</p>
        <hr />
        
        <h3 css={style.subTitle01}>健康ウォーキング教室</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>毎週土曜日&emsp;9:30～10:00</h4>
        <p>ラジオ体操、ウォーキング</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】新潟ふれ愛プラザ（新潟市江南区）</span>&emsp;電話：<a href="tel:025-381-8110">025-381-8110</a><br />ホームページは<a href="https://n-fureaiplaza.com/" target="_blank" rel="noreferrer">こちら</a></p>
        <hr />
        
        <h3 css={style.subTitle01}>GWフェスティバル</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/29（土・祝）～5/7（日）</h4>
        <p>お酒市、縁日屋台など</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】新潟ふるさと村（新潟市西区）</span>&emsp;電話：<a href="tel:025-230-3030">025-230-3030</a><br />ホームページは<a href="http://furusatomura.pref.niigata.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-18.png`}
          alt="GWフェスティバル"
          css={style.img(500, "15px 0 0 0")}
        />
        <hr />
        
        <h3 css={style.subTitle01}>古文書初級解読講座（夏季）</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>Aコース&ensp;6/30（金）・7/14（金）<br />Bコース&ensp;7/5（水）・7/12（水）<br />両コースとも13:30～15:30&emsp;2回連続講座</h4>
        <p>受講申込開始：5/30（火）&ensp;料金：100円&emsp;定員：45人（先着順）</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立文書館（新潟市中央区）</span>&emsp;電話：<a href="tel:025-284-6011">025-284-6011</a><br />ホームページは<a href="https://www.pref-lib.niigata.niigata.jp/1b8446f94c08f7ae67441d7d895601a6" target="_blank" rel="noreferrer">こちら</a></p>
        <hr />
        
        <h3 css={style.subTitle01}>企画展1&emsp;発掘された名前</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/21（金）～12/17（日）</h4>
        <p>木簡や墨書土器など文字資料の中から、人名、施設名、地名など「名前」から見える人と社会の実像に迫ります。</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県埋蔵文化財センター（新潟市秋葉区）</span>&emsp;電話：<a href="tel:0250-25-3981">0250-25-3981</a><br />ホームページは<a href="https://www.maibun.net/" target="_blank" rel="noreferrer">こちら</a></p>

        <hr />
        
        <h3 css={style.subTitle01}>県立近代美術館開館30周年記念<br />望郷の画家&emsp;橋本龍美展<br />―神も、庶民も、バケモノも</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/15（土）～6/4（日）</h4>
        <p>休館：月（5/1は開館）<br />料金：一般1,200円、高校・大学生1,000円<br />※障害者手帳をお持ちの方は無料</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立近代美術館（長岡市）</span>&emsp;電話：<a href="tel:0258-28-4111">0258-28-4111</a><br />ホームページは<a href="https://kinbi.pref.niigata.lg.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-19.png`}
          alt="橋本龍美《風之唄》"
          css={style.img(500, "15px 0 0 0")}
        />
        <p css={style.imgCap}>橋本龍美《風之唄》1981年／当館蔵</p>
        <hr />
        
        <h3 css={style.subTitle01}>春季企画展「伝える―災害の記憶&emsp;あいおいニッセイ同和損保所蔵災害資料」</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>4/22（土）～6/4（日）</h4>
        <p>休館：月<br />料金：一般840円、高校・大学生600円</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立歴史博物館（長岡市）</span>&emsp;電話：<a href="tel:0258-47-6130">0258-47-6130</a><br />ホームページは<a href="http://nbz.or.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-20.png`}
          alt="鯰を押える鹿島大明神"
          css={style.img(300, "15px 0 0 0")}
        />
        <p css={style.imgCap}>「鯰を押える鹿島大明神」安政2（1855）年／あいおいニッセイ同和損害保険株式会社所蔵</p>
        <hr />
        
        <h3 css={style.subTitle01}>猫の飼い方セミナー&emsp;初級</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>6/11（日）13:30～15:00</h4>
        <p>定員：20人（申込先着順）</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県動物愛護センター（長岡市）</span>&emsp;電話：<a href="tel:0258-21-5501">0258-21-5501</a><br />ホームページは<a href="https://www.pref.niigata.lg.jp/site/da-top/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-21.png`}
          alt="猫の飼い方セミナー"
          css={style.img(500, "15px 0 0 0")}
        />
        <hr />
        
        <h3 css={style.subTitle01}>浅草山麓エコ・ミュージアム&emsp;一般開園開始</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>6月上旬</h4>
          <p><span css={no162Style.eventAddr}>【問い合わせ】浅草山麓エコ・ミュージアム（魚沼市）</span>&emsp;電話：<a href="tel:025-798-4141">025-798-4141</a><br />ホームページは<a href="http://www.eco-museum.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-22.png`}
          alt="浅草山麓エコ・ミュージアム"
          css={style.img(500, "15px 0 0 0")}
        />
        <hr />
        
        <h3 css={style.subTitle01}>ゴールデンウィーク☆あそびフェスタ2023</h3>
        <h4 css={[style.subTitle02,no162Style.eventDate]}>5/3（水・祝）～7（日）</h4>
        <p>はたらくくるま大集合、けん玉パフォーマンスなど<br />料金：体験により異なります。</p>
          <p><span css={no162Style.eventAddr}>【問い合わせ】県立こども自然王国（柏崎市）</span>&emsp;電話：<a href="tel:0257-41-3355">0257-41-3355</a><br />ホームページは<a href="https://www.garuru-kururu.jp/" target="_blank" rel="noreferrer">こちら</a></p>

        <img
          src={`${basePath}/no162/img/2-23.png`}
          alt="ゴールデンウィーク☆あそびフェスタ2023"
          css={style.img(500, "15px 0 0 0")}
        />
        <hr />


        <BackBtn href={"/no162"} />
      </Content>
    </Page>
  )
}
export default Home
